import { useState, useContext } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { FiLock } from 'react-icons/fi'

import Input from '../../shared/components/form/Input'
import PasswordChecklist from '../../shared/components/form/PasswordChecklist'
import { Context } from '../../context/UserContext'

import './auth.css'

function ResetPassword() {
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token')
    const [form, setForm] = useState({})
    const [loading, setLoading] = useState(false)
    const { resetPassword } = useContext(Context)

    function handleChange(e) {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    async function handleSubmit(e) {
        e.preventDefault()
        setLoading(true)
        await resetPassword(token, form.password, form.confirmPassword)
        setLoading(false)
    }

    if (!token) {
        return (
            <div className="auth">
                <div className="auth-box panel">
                    <h1 className="auth-title">Redefinir senha</h1>
                    <p className="auth-subtitle">Link de redefinição inválido.</p>
                    <p className="auth-switch">
                        <Link to="/esqueci-senha">Pedir um novo link</Link>
                    </p>
                </div>
            </div>
        )
    }

    return (
        <div className="auth">
            <div className="auth-box panel">
                <p className="auth-eyebrow">Acesso à arena</p>
                <h1 className="auth-title">Redefinir senha</h1>
                <p className="auth-subtitle">Escolha uma nova senha pra sua conta.</p>

                <form onSubmit={handleSubmit} className="auth-form">
                    <Input
                        text="Nova senha"
                        type="password"
                        name="password"
                        handleOnChange={handleChange}
                        value={form.password || ''}
                    />
                    <PasswordChecklist password={form.password} />
                    <Input
                        text="Confirmar nova senha"
                        type="password"
                        name="confirmPassword"
                        placeholder="Repita a nova senha"
                        handleOnChange={handleChange}
                        value={form.confirmPassword || ''}
                    />

                    <button className="btn-primary auth-submit" type="submit" disabled={loading}>
                        <FiLock size={16} />
                        {loading ? 'Salvando...' : 'Redefinir senha'}
                    </button>
                </form>

                <p className="auth-switch">
                    <Link to="/login">Voltar pro login</Link>
                </p>
            </div>
        </div>
    )
}

export default ResetPassword
